var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.667 23.133L17.233 22l1.7-13.033h-13.7l2.434 14.166z",
    fill: "#F8E0FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.567 9.667l-14.7 1.566L4 9l16-1.467-.433 2.134z",
    fill: "#0C0A0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.826 17.442c1.072-.488 1.602-1.631 1.182-2.553-.419-.921-1.628-1.273-2.7-.785-1.073.488-1.603 1.63-1.184 2.552.42.922 1.63 1.274 2.702.786zM7.533 10.067a8.856 8.856 0 00-.133-2.2c-.167-.834-.4-1.5-.633-2 2.1-.7 4.2-1.434 6.3-2.134",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.067 4.4l2-.667",
    stroke: "#0C0A0C",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.367 1.833l.933-1M15.6 4.533l1.433.134M15.333 3.067L17.3 2.1",
    stroke: "#0C0A0C",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgConference;